var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showDespachos
    ? _c("div", [
        _c(
          "h3",
          [
            _vm._v("Despacho"),
            _vm._l(_vm.despachos, function(conteudo, index) {
              return _c(
                "app-collapse",
                {
                  key: conteudo.id,
                  attrs: { title: _vm.title, collapsed: "1" }
                },
                [
                  _c("b", [_vm._v("Responsável:")]),
                  _c("p", [
                    _vm._v(
                      _vm._s(conteudo.usuario.pessoa.pessoaFisica.nome) +
                        " (" +
                        _vm._s(_vm.capitalizarPalavra(conteudo.perfil)) +
                        ")"
                    )
                  ]),
                  _c("b", [_vm._v("Despacho:")]),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(conteudo.textoDespacho) }
                  }),
                  _c(
                    "el-table",
                    { attrs: { data: conteudo.documentos, stripe: "stripe" } },
                    [
                      _c("div", { attrs: { slot: "empty" }, slot: "empty" }, [
                        _c("span", [_vm._v("Não há anexos disponíveis.")])
                      ]),
                      _c("el-table-column", {
                        staticClass: "td-column-anexo",
                        attrs: { prop: "nome" }
                      }),
                      _c("el-table-column", {
                        staticClass: "td-column-anexo",
                        attrs: { align: "center", width: "85" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("app-action-button", {
                                    attrs: {
                                      icone: "download",
                                      nome: "file_download",
                                      hoverColor: "#009f61",
                                      text: "Baixar anexo"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.baixarAnexo(scope.row)
                                      }
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed3bceec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed3bceec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDespachoSimplificado.vue
// module id = null
// module chunks = 